import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mt-10 lg:mt-20 flex flex-col items-center" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "border-l border-dashed border-amff-pink h-14 lg:h-20" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ArrowIcon = _resolveComponent("ArrowIcon")
  const _component_Button = _resolveComponent("Button")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_Button, {
      as: _ctx.AnchorLink,
      to: { name: 'events' },
      class: "mt-6 lg:mt-10",
      color: "amff-pink"
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t("home.see_the_full_program")) + " ", 1),
        _createVNode(_component_ArrowIcon, {
          fill: "currentColor",
          class: "ml-2 w-4 h-4"
        })
      ]),
      _: 1
    }, 8, ["as"])
  ]))
}